﻿import { Routes, RouterModule } from '@angular/router';
import { MainComponent } from './main/main.component';
import { LoginComponent } from './login/login.component';
import { AuthGuard } from './auth.guard';
import { MainResolver } from './main/main.resolver';
import { CustomPreloading } from './app.custom-preloading';
import { ResetPasswordModule } from './reset_password/reset-password.module';
import { EnrollProvidersModule } from './enroll_providers/enroll-providers.module';
import { EnrollPatientModule } from './enroll_patient/enroll-patient.module';

export const routes: Routes = [
    {
        path: '',
        component: MainComponent,
        canActivate: [AuthGuard],
        resolve: { main: MainResolver },
        children: [
            { path: '', data: { menuValue: [""] }, loadChildren: './user_information/user-information.module#UserInfortionsModule' },
            { path: 'patient-records', data: { menuValue: ["DRPR01", "ADPF05"] }, loadChildren: './patient_records/patient-records.module#PatientRecordsModule' },
            { path: 'create-soap-note', data: { menuValue: ["ADAN07"] }, loadChildren: './alert_networks/create_soap_notes/create-soap-notes.module#CreateSoapNotesModule' },
            { path: 'alert-management', data: { menuValue: ["ADAN08"] }, loadChildren: './alert_networks/alert_management/alert-management.module#AlertManagementModule' },
            { path: 'incoming-soap-alerts', data: { menuValue: ["ADAN09"] }, loadChildren: './alert_networks/incoming_soap_alerts/incoming-soap-alerts.module#IncomingSOAPAlertsModule' },
            { path: 'outgoing-soap-alerts', data: { menuValue: ["ADAN10"] }, loadChildren: './alert_networks/outgoing-soap-alerts/outgoing-soap-alerts.module#OutgoingSoapAlertsModule' },
            { path: 'alert-soap-chronology', data: { menuValue: ["ADAN11"] }, loadChildren: './alert_networks/soap_chronology/soap-chronology.module#SOAPChronologyModule' },
            { path: 'demographics-editor', data: { menuValue: ["DRED07"] }, loadChildren: './demographics_editor/demographics-editor.module#DemographicsEditorModule' },
            { path: 'user-information', data: { menuValue: ["ADUI12", "ADUI14"] }, loadChildren: './user_information/user-information.module#UserInfortionsModule' },
            { path: 'user-settings', data: { menuValue: ["ADUS01"] }, loadChildren: './user_settings/user-settings.module#UserSettingsModule' },
            { path: 'change-password', data: { menuValue: ["ADCP13"] }, loadChildren: './change_password/change-password.module#ChangePasswordModule' },
            { path: 'calendar', data: { menuValue: ["DRPC01"] }, loadChildren: './calendar/calendar.module#CalenderModule' },
            { path: 'demographics/:patientKey', data: { menuValue: ["DRPD02"] }, loadChildren: './demographics_editor/edit_demographic/edit-demographic.module#EditDemographicModule' },
            { path: 'record-viewer/:patientKey', data: { menuValue: ["DRRV04"] }, loadChildren: './patient_features/patient-features.module#PatientFeaturesModule' },
            { path: 'ancillary-providers', data: { menuValue: ["DRRA06"] }, loadChildren: './ancillary_providers/ancillary-providers.module#AncillaryProvidersModule' },
            { path: 'ancillary-providers-administrative', data: { menuValue: ["ADUM02"] }, loadChildren: './manage_ancillary_providers/manage-ancillary-providers.module#ManageAncillaryProvidersModule' },
            { path: 'admin-enroll-provider', data: { menuValue: ["ADUM03"] }, loadChildren: './admin/admin-enroll_providers/admin-enroll-providers.module#AdminEnrollProvidersModule' },
            { path: 'admin-enroll-patient', data: { menuValue: ["ADUM04"] }, loadChildren: './admin/admin_enroll_patient/admin-enroll-patient.module#AdminEnrollPatientModule' },
            { path: 'admin-group-management', data: { menuValue: ["ADGM02"] }, loadChildren: './admin/admin_group_management/admin-group-management.module#AdminGroupManagementModule' },
            { path: 'admin-user-management', data: { menuValue: ["ADUM01"] }, loadChildren: './admin/admin_user_management/admin-user-management.module#AdminUserManagementModule' },
            { path: 'demographics-viewer', data: { menuValue: ["DRDV03"] }, loadChildren: './admin/demographics_viewer/demographics-viewer.module#DemographicsViewerModule' },
            { path: 'admin-usage-history', data: { menuValue: ["ASUH01"] }, loadChildren: './admin/admin_usage_history/admin-usage-history.module#AdminUsageHistoryModule' }
        ]
    },
    {
        path: 'login',
        component: LoginComponent
    },
    {
        path: 'reset-password',
        loadChildren: './reset_password/reset-password.module#ResetPasswordModule'
    },
    {
        path: 'enroll-provider',
        loadChildren: './enroll_providers/enroll-providers.module#EnrollProvidersModule'        
    },
    {
        path: 'enroll-patient',
        loadChildren: './enroll_patient/enroll-patient.module#EnrollPatientModule'
    },
    {
        path: 'page-not-found',
        loadChildren: './page_not_found/page-not-found.module#PageNotFoundModule'
    },
    {
        path: '**',
        redirectTo: "/page-not-found"
    }
];

export const routing = RouterModule.forRoot(routes, { preloadingStrategy: CustomPreloading });